export const weatherURL = 'https://api.darksky.net';

export const weatherAPI = 'e89924fd4955c48e77af45cfab3bcec3';

export const stockURL = 'https://www.quandl.com';

export const stockAPI = '6Vy6THRmgxaNTkr7tqcy';



// WEBPACK FOOTER //
// ./src/api/key.js